import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '@bvt-atoms';
import './DemoCath.scss';
import { BaseCard } from '@bvt-shared/component/BaseCard';

/**
 *
 * @param {object} props
 * @param {object} props.femaleCount
 * @param {string|number} props.femaleCount.percentage
 * @param {string|number} props.femaleCount.persentase
 * @param {string|number} props.femaleCount.value
 * @param {object} props.maleCount
 * @param {string|number} props.maleCount.percentage
 * @param {string|number} props.maleCount.persentase
 * @param {string|number} props.maleCount.value
 * @param {object} props.totalCount
 * @param {string|number} props.totalCount.percentage
 * @param {string|number} props.totalCount.persentase
 * @param {string|number} props.totalCount.value
 *
 */

export default function DemoCath(props) {
  const progressDataTotal = [
    {
      color: '#12b2a7',
      percent: props?.totalCount?.persentase || props?.totalCount?.percentage || 0,
      type: 'Population Get',
      count: props?.totalCount?.value?.toLocaleString('id-ID') || 0,
    },
  ];

  const progressDataMale = [
    {
      color: '#8B9DB2',
      percent: props?.maleCount?.persentase || props?.maleCount?.percentage || 0,
      type: 'Male',
      count: props?.maleCount?.value?.toLocaleString('id-ID') || 0,
      svg: 'male',
    },
  ];

  const progressDataFemale = [
    {
      color: '#8B9DB2',
      percent: props?.femaleCount?.persentase || props?.femaleCount?.percentage || 0,
      type: 'Female',
      count: props?.femaleCount?.value?.toLocaleString('id-ID') || 0,
      svg: 'female',
    },
  ];
  return (
    <div id='GrianaDashboardDemoCatch' style={props?.style}>
      <BaseCard isLoading={props?.isLoading} title='Demography catchment' withPadding={true}>
        <ProgressBar data={progressDataTotal} />
        <ProgressBar data={progressDataMale} />
        <ProgressBar data={progressDataFemale} />
      </BaseCard>
    </div>
  );
}

DemoCath.propTypes = {
  femaleCount: PropTypes.shape({
    persentase: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  maleCount: PropTypes.shape({
    persentase: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  totalCount: PropTypes.shape({
    persentase: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};
